import React from "react";

export default function DownloadButton() {
  return (
    <a
      href="/catalogue.pdf"
      download="GEFI-Catalogue.pdf"
      className="download-catalogue medium"
    ></a>
  );
}
